module.exports = __webpack_public_path__ + "static/media/MarkPro-Book.04b747bb.woff";